import { parseProductNameMarkup, productDisplayName } from "./productText";

interface ProductNameTextProps {
  name?: unknown;
  sku?: unknown;
}

export function ProductNameText({ name, sku }: ProductNameTextProps) {
  const tokens = parseProductNameMarkup(name);
  const hasVisibleName = tokens.some(
    (token) => token.type !== "break" && token.text.trim(),
  );

  if (!hasVisibleName) {
    return <>{productDisplayName(name, sku)}</>;
  }

  return (
    <>
      {tokens.map((token, index) => {
        if (token.type === "break") {
          return <br key={`br-${index}`} />;
        }
        if (token.type === "sup") {
          return <sup key={`sup-${index}`}>{token.text}</sup>;
        }
        return token.text;
      })}
    </>
  );
}
